import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class KnowledgeShareTagApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'knowledgeshare-tag'
  }

}